import CommonDashboardIndexRoute from 'ilios-common/routes/dashboard/index';

export default class DashboardIndexRoute extends CommonDashboardIndexRoute {}
